import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
} from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { STORAGE } from "src/app/constant/storages";
import {
  _deleteStorage,
  _getStorage,
  _setStorage,
} from "src/app/utils/local-storage";
import { ApiserviceService } from "../../../../app/httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { TEXT } from "../../../text_control";

@Component({
  selector: "app-credit-save-taxinvoice",
  templateUrl: "./credit-save-taxinvoice.component.html",
  styleUrls: ["./credit-save-taxinvoice.component.scss"],
})
export class CreditSaveTaxinvoiceComponent implements OnInit {
  email: string = "";
  creditNoteData: any;
  searchCreditNode: any;
  storeResponse: any;
  label_text: any = {};
  Active: number;
  isShowBranchNo: any;
  remark = "";

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";
  headerSourceConnection: any;

  constructor(
    public alertController: AlertController,
    public modalCtrl: ModalController,
    public router: Router,
    public apiservice: ApiserviceService,
    public appService: AppService,
    public storage: Storage,
    public loadingController: LoadingController,
    public route: ActivatedRoute,
    public navParams: NavParams
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.headerSourceConnection = _getStorage(
      STORAGE.sourceConnectionCreditNote
    );
    this.label_text = TEXT;
    this.isShowBranchNo = navParams.get("isShowBranchNo");
    this.remark = navParams.get("remark");
  }

  ngOnInit() {
    console.log("remark====: ", this.remark);
    console.log("isShowBranchNo====: ", this.isShowBranchNo);

    this.appService.setActive(4);
  }

  async ionViewWillEnter() {
    this.route.queryParams.subscribe((params) => {
      console.log("params....", params);
      if (params.noName === "no_cn") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 3;
      }
    });
    await this.getStorageData();
  }

  async getStorageData() {
    const resVer = _getStorage(STORAGE.verifyCreditNote);
    console.log("[getStorageData] creditNoteData res : ", resVer);
    this.creditNoteData = typeof resVer === "string" ? resVer : resVer;

    this.email = this.creditNoteData.buyer.address_info.email;

    const res = _getStorage(STORAGE.searchCreditNode);
    console.log("[getStorageData] searchCreditNode res : ", res);
    this.searchCreditNode =
      typeof res === "string" ? JSON.parse(res) : res.request;
    this.storeResponse =
      typeof res === "string" ? JSON.parse(res) : res.response;
  }

  async validateEmail() {
    const alert = await this.alertController.create({
      cssClass: "resend-confirm-email",
      header: "รูปแบบ email ไม่ถูกต้อง",
      buttons: [
        {
          text: "OK",
          role: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  onDisableClick: boolean = false;
  async confirmWaitAlert() {
    if (this.email) {
      const re =
        /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) return this.validateEmail();
    }
    console.log("this.onDisableClick", this.onDisableClick);
    this.onDisableClick = true;
    setTimeout(async () => {
      await this.confirmAlert();
    }, 2000);
  }

  async confirmAlert() {
    console.log(" ------------------ [confirmAlert] ------------------ ");
    let data = {};

    let isOldAbbTransaction = window.localStorage.isOldAbb;
    if (isOldAbbTransaction === "Y") {
      console.log(" >>>>>>>>>>>>>>>>>> OLD TRANSACTION <<<<<<<<<<<<<<<<<<<");
      data = {
        creditnote: {
          buyer_id: this.creditNoteData.buyer.buyer_id,
          confirmreplace: "confirm",
          searchABB: {
            userid: this.userID,
            userSource: this.userSource,
            bu: this.userBu,
            loc: this.userLoc,
            receiptno: this.searchCreditNode.cn_tax_receipt,
            tpno: this.searchCreditNode.tpno,
            templatetype: "CN",
            receipt_date: this.searchCreditNode.receipt_date,
          },
          doctype: "2",
          email: this.email,
          remark: this.remark,
          isShowBranchNo: this.isShowBranchNo,
          taxinvoice_no:
            this.storeResponse.taxinvoice_list[0].ref_tax_invoice_no,
          posecode: this.searchCreditNode.cn_reason,
          posecode_desc: this.searchCreditNode.cn_remark,
          user_id: this.userID,
          userBu: this.userBu,
          userLoc: this.userLoc,
          userRole: this.userRole,
        },
      };
    } else {
      console.log(" >>>>>>>>>>>>>>>>>> NEW TRANSACTION <<<<<<<<<<<<<<<<<<<");
      data = {
        creditnotefulltax: {
          buyer_id: this.creditNoteData.buyer.buyer_id,
          confirmreplace: "confirm",
          searchABB: {
            userid: this.userID,
            userSource: this.userSource,
            bu: this.userBu,
            loc: this.userLoc,
            receiptno: this.searchCreditNode.cn_tax_receipt,
            tpno: this.searchCreditNode.tpno,
            type: "CN",
            receipt_date: this.searchCreditNode.receipt_date,
          },
          doctype: "2",
          remark: this.remark,
          email: this.email,
          isShowBranchNo: this.isShowBranchNo,
          posecode: this.searchCreditNode.cn_reason,
          posecode_desc: this.searchCreditNode.cn_remark,
          userBu: this.userBu,
          userLoc: this.userLoc,
          userRole: this.userRole,
          user_id: this.userID,
        },
      };
    }

    console.log("======== req confirm send email=======", data);
    try {
      this.apiservice
        ._post(
          this.apiservice.apiUrl + this.apiservice.confirmCreate,
          data,
          this.headerSourceConnection
        )
        .then(async (res: any) => {
          console.log("(post) [createCreditNote] response : ", res);

          if (res.statusCode == 200) {
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              header:
                "ระบบได้ดำเนินการส่งรายละเอียด เพื่อสร้างเอกสารอิเล็กทรอนิกส์เรียบร้อยแล้ว โดยนำส่งตาม E-mail ที่มีการระบุไว้",
            });

            await alert.present();
            setTimeout(async () => {
              let previewData = this.setInvoiceList([res.data]);
              console.log(
                "before confirmCreditNote previewData : ",
                previewData
              );
              _setStorage(STORAGE.confirmCreditNote, previewData);
              _deleteStorage(STORAGE.sourceConnectionCreditNote);
              // this.storage.set("confirmCreditNote", previewData);
              alert.dismiss(true);
              this.modalCtrl.dismiss({ dismissed: true });
              if (this.Active === 3) {
                this.router.navigate(["credit-note-preview"]);
              } else {
                this.router.navigate(["credit-note-preview"], {
                  queryParams: { noName: "no_cn", selectedIndex: "4" },
                });
              }
            }, 5000);
          } else {
            this.onDisableClick = false;
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      this.onDisableClick = false;
      // this.ErrorMsg(errMsg.error);
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  setInvoiceList(data: any) {
    if (data instanceof Array) data = data[0];
    return {
      invoice_list: [
        {
          seq: 1,
          receiptno: data.receiptNo,
          receiptno_ref: data.receiptNo_ref,
          invoiceno: data.taxinvoice_no === undefined ? "" : data.taxinvoice_no,
          creditnoteno: data.new_taxinvoice_no,
          taxid: data.customerData[0].buyer_tax_id,
          buyer_type: data.customerData[0].buyer_type,
          branch:
            data.customerData[0].buyer_main_branch_no == ""
              ? data.customerData[0].buyer_branch_no
              : data.customerData[0].buyer_main_branch_no,
          address_display:
            data.customerData[0].address_detail[0].type_addr === "1"
              ? data.customerData[0].address_detail[0].addr_info
              : data.customerData[0].address_detail[0].addr_infoEN,
          email: data.lasted_email,
          download_pdf: data.inet_response.pdfURL,
          download_xml: data.inet_response.xmlURL,
          mtrans_id: data.mtrans_id,
        },
      ],
    };
  }

  dismiss() {
    this.modalCtrl
      .dismiss({
        dismissed: true,
      })
      .then((res: any) => {
        if (res) {
        }
      });
  }

  cancelAlert() {
    this.appService.setActive(3);
    this.dismiss();
  }
}
